var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_7381)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.886 4.27245C4.03505 3.97833 4.33678 3.79297 4.66651 3.79297H9.64467C9.9234 3.79297 10.1855 3.92576 10.3503 4.15054L24.0388 22.8172C24.2338 23.0831 24.2627 23.436 24.1137 23.7302C23.9646 24.0243 23.6629 24.2096 23.3332 24.2096H18.355C18.0763 24.2096 17.8142 24.0768 17.6494 23.8521L3.9609 5.1854C3.76591 4.9195 3.73696 4.56657 3.886 4.27245ZM6.39321 5.54297L18.7984 22.4596H21.6065L9.20127 5.54297H6.39321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9519 4.04925C24.2936 4.39096 24.2936 4.94498 23.9519 5.28669L16.0512 13.1874C15.7095 13.5291 15.1555 13.5291 14.8138 13.1874C14.4721 12.8456 14.4721 12.2916 14.8138 11.9499L22.7144 4.04925C23.0562 3.70754 23.6102 3.70754 23.9519 4.04925ZM13.1812 14.8199C13.5229 15.1616 13.5229 15.7156 13.1812 16.0574L5.28522 23.9534C4.94351 24.2951 4.38949 24.2951 4.04779 23.9534C3.70608 23.6116 3.70608 23.0576 4.04779 22.7159L11.9438 14.8199C12.2855 14.4782 12.8395 14.4782 13.1812 14.8199Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_7381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7deea7de6786b95812913e8312e5aae0.svg";
export { ForwardRef as ReactComponent };